import React from 'react'

type SwitchIconProps = React.HTMLAttributes<SVGElement> & {
  width?: number | string
  height?: number | string
  fill?: string
}

export const SwitchIcon = ({
  width = 10,
  height = 10,
  fill = 'currentColor',
  ...props
}: SwitchIconProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.70703 7.11328L7.83203 8.98828C7.63672 9.18359 7.34375 9.18359 7.16797 8.98828L5.29297 7.11328C5.09766 6.9375 5.09766 6.64453 5.29297 6.46875C5.46875 6.27344 5.76172 6.27344 5.95703 6.46875L7.03125 7.54297V0.84375C7.03125 0.589844 7.22656 0.375 7.5 0.375C7.75391 0.375 7.96875 0.589844 7.96875 0.84375V7.54297L9.04297 6.46875C9.21875 6.27344 9.51172 6.27344 9.70703 6.46875C9.88281 6.64453 9.88281 6.9375 9.70703 7.11328ZM2.83203 0.511719L4.6875 2.38672C4.88281 2.58203 4.88281 2.875 4.6875 3.05078C4.51172 3.24609 4.21875 3.24609 4.04297 3.05078L2.96875 1.97656V8.65625C2.96875 8.92969 2.75391 9.125 2.5 9.125C2.22656 9.125 2.03125 8.92969 2.03125 8.65625L2.01172 1.97656L0.9375 3.05078C0.761719 3.24609 0.46875 3.24609 0.292969 3.05078C0.0976562 2.875 0.0976562 2.58203 0.292969 2.38672L2.16797 0.511719C2.34375 0.335938 2.63672 0.335938 2.83203 0.511719Z"
        fill={fill}
      />
    </svg>
  )
}
